import { createRoot } from 'react-dom/client';
import { PartnerConfigProvider } from '../libs/providers/PartnerConfigProvider';
import { ApolloProvider } from '@apollo/client';
import client from '../libs/configs/graphqlClientConfig';
import EligibilityWidget from './EligibilityWidget';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import ThemeProviderStandalone from '../libs/providers/ThemeProviderStandalone';
import EligibilityWidgetError from './components/EligibilityWidgetError';

export const initialize = (rootId: string, pid: string, apiKey: string, language: string) => {
  const root = document.getElementById(rootId);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="*"
        errorElement={<EligibilityWidgetError pid={pid} apiKey={apiKey} language={language} />}
        element={<EligibilityWidget pid={pid} apiKey={apiKey} language={language} />}
      />,
    ),
  );

  if (root) {
    createRoot(root).render(
      <ApolloProvider client={client}>
        <PartnerConfigProvider pid={pid} requestId={''} language={language}>
          <ThemeProviderStandalone appName="eligibilityWidget" pid={pid} scopeCssBaseline>
            <RouterProvider router={router} />
          </ThemeProviderStandalone>
        </PartnerConfigProvider>
      </ApolloProvider>,
    );
  } else {
    console.error('Impossible to find element with id', rootId);
  }
};

export const destroy = (rootId: string) => {
  const root = document.getElementById(rootId);
  if (root) {
    root.innerHTML = '';
  }
};
